import React from 'react';
import { createRoot } from 'react-dom/client';
import { OfferLike } from '../../component/offer/like/OfferLike';
import Client from '../../model/api/Client';
import AccountClient from '../../model/api/account/Client';

const client = new AccountClient(new Client());

document.querySelectorAll('[data-offer-like]').forEach((element) => {
	createRoot(element).render(
		<OfferLike
			offerId={Number(element.dataset.offerId)}
			initialLiked={element.dataset.liked === 'true'}
			isLoggedIn={element.dataset.loggedIn === 'true'}
			signUpUrl={element.dataset.signUpUrl}
			client={client}
		/>
	);
});
